import { React, Suspense, useEffect, useState } from "react";
import { useEventsContext, usePowerContext } from "src/hooks/use-alert";
import "./ItemMonitoring.css";
import { Grid } from "@mui/material";
import { getAsset } from "src/apis/complex";
import DoughnutChart from "src/components/DoughnuGauget";
import { GaugeChart2 } from "src/components/Charts/GoogleGaugeComponent ";
import { Await } from "react-router-dom";
import ButtonPolicy from "../Permission/ButtonPolicy";
import PlantControl from "../PlantControl/PlantControl";
import ControlPlantContainer from "../ControlPlant/ControlPlantContainer";
export default function ItemMonitoring({ props }) {
  const { events } = useEventsContext();
  const [alerts, setAlerts] = useState([]);
  const [itemsValue, setItemValues] = useState([]); //array of items
  const assetId = props.assetId;
  const [assetData, setAssetData] = useState(null);
  const [openPlant, setOpenPlant] = useState(false);
  const [openControl, setOpenControl] = useState(false);

  useEffect(() => {
    console.log(assetId);
    const fetchData = async () => {
      try {
        const asset = await getAsset(assetId);
        setAssetData(asset);
      } catch (error) {
        // Handle error if needed
      }
    };

    fetchData(); // Call the fetchData function immediately
  }, []);
  //console.log(assetData);

  var x = itemsValue;
  useEffect(() => {
    setAlerts(events.data);
  }, [events.data]);
  const handleClickOpen = () => {
    setOpenPlant(true);
  };
  const handleClickClose = () => {
    setOpenPlant(false);
  };

  useEffect(() => {
    if (assetData) {
      setItemValues(assetData.items);
    }
  }, [assetData]);

  if (x.length !== 0) {
    var y = x.map((item) => {
      if (!item.hasOwnProperty("value")) {
        item.value = 0;
      }
      if (
        alerts.find((x) => x.title === item.serialNumber) !== undefined &&
        alerts.find((x) => x.title === item.serialNumber).value !== item.value
      ) {
        // console.log(
        //   item.serialNumber +
        //   ": prev = " +
        //   item.value +
        //   " new = " +
        //   alerts.find((x) => x.title === item.serialNumber).value
        // );
        item.value = alerts.find((x) => x.title === item.serialNumber).value;
      } else if (
        alerts.find((x) => x.title === item.serialNumber) !== undefined
      ) {
        // console.log(
        //   item.serialNumber +
        //   ": prev = " +
        //   item.value +
        //   " new = " +
        //   alerts.find((x) => x.title === item.serialNumber).value
        // );
      }
      return item;
    });
    if (y.toString() !== x.toString()) {
      setItemValues(y);
    }
  }

  // syntax data_loaded = useRouteLoaderData("id of component in App.js")
  // I use it to access the loaded data through the function passed to the loader in App.js

  //POWERS
  const { powers } = usePowerContext();
  const [activePower, setActivePower] = useState(0);
  const [reactivePower, setReactivePower] = useState(0);
  const [energyConsumption, setEnergyConsumption] = useState(0);

  useEffect(() => {
    //se arrivano potenze aggiornate dal socket allora aggiorno i valori degli items appertenenti a questa organization
    if (powers.data.length > 0) {
      itemsValue.forEach((item) => {
        var matchedItem = powers.data.find(
          (power) => power.title === item.serialNumber
        );
        if (matchedItem !== undefined) {
          item.lastRegisteredValue = Number.parseFloat(
            matchedItem.value.split(" ")[0].substring(0, 3)
          );
        }
      });
    }

    var newActive = 0;
    var newReactive = 0;
    var energyConsumption = 0;

    //altrimenti sommo la proprietà lastRegisteredValue che appartiene agli items dell'org
    itemsValue.forEach((item) => {
      if (item.itemType.name === "Asset Total Power") {
        energyConsumption += item.lastRegisteredValue;
      }
      if (item.itemType.name === "Active Power Observer") {
        newActive += item.lastRegisteredValue;
      }
      if (item.itemType.name === "Reactive Power Observer") {
        newReactive += item.lastRegisteredValue;
      }
    });

    setActivePower(newActive);
    setReactivePower(newReactive);
    setEnergyConsumption(energyConsumption);
  }, [powers, itemsValue]);

  return (
    // Render this till data is loaded
    <Suspense
      fallback={
        <p style={{ color: "#FFF", textAlign: "center" }}>Loading...</p>
      }
    >
      <Await resolve={assetData}>
        {(assetData) => {
          return (
            <div className="Office">
              <div className="homeContainerOffice">
                <PlantControl visbile={openPlant} onClose={handleClickClose} />
                <Grid container>
                  <Grid md={12} lg={12} sm={12} xs={12}>
                    <div className="buildDetails">
                      <Grid container spacing={2}>
                        {/* Gauge 1 */}
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                          <div className="infoButton">
                            <ButtonPolicy
                              onClick={() => handleClickOpen()}
                              /* onClick={() => setOpenControl(true)} */
                              variant="contained"
                              sx={{
                                width: 150,
                                borderRadius: "0",
                              }}
                            >
                              Control Plant
                            </ButtonPolicy>
                          </div>
                        </Grid>
                        <Grid item md={4} lg={4} sm={6} xs={12}>
                          <DoughnutChart
                            currentValue={(activePower / (5 * 1.5)).toFixed(2)}
                            maxValue={2}
                          />
                          <div className="cen">Active Power</div>
                          <div className="cen">
                            {activePower.toFixed(2) + " kW"}
                          </div>
                        </Grid>
                        {/* Gauge 2 */}
                        <Grid item md={4} lg={4} sm={6} xs={12}>
                          <DoughnutChart
                            currentValue={(reactivePower / (5 * 1.5)).toFixed(
                              2
                            )}
                            maxValue={2}
                          />
                          <div className="cen">Reactive Power</div>
                          <div className="cen">
                            {reactivePower.toFixed(2) + " KVAr"}
                          </div>
                        </Grid>
                        {/* Gauge 3 */}
                        <Grid item md={4} lg={4} sm={6} xs={12}>
                          <DoughnutChart
                            currentValue={(
                              energyConsumption /
                              (5 * 1.5)
                            ).toFixed(2)}
                            maxValue={2}
                          />
                          <div className="cen">Energy Consuption</div>
                          <div className="cen">
                            {energyConsumption.toFixed(2) + " kWh"}
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  {assetData &&
                    assetData.items.map((item, index) => {
                      if (
                        item.itemType.name === "Asset Total Power" ||
                        item.itemType.name === "Active Power Observer" ||
                        item.itemType.name === "Reactive Power Observer"
                      ) {
                        return null;
                      }
                      return (
                        <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                          <div className="dangerContainer">
                            <div className="danger">
                              <div className="HeadingOfDanger">
                                {item.itemType.name}
                              </div>
                              <div className="bodyOfDanger">
                                {/* <div className="value">{alerts.find(x => x.serialNumber === item.serialNumber).value ?? item.value ?? 0}</div> */}
                                <GaugeChart2
                                  label=""
                                  value={parseFloat(
                                    alerts.find(
                                      (x) => x.title === item.serialNumber
                                    ) !== undefined
                                      ? alerts.find(
                                          (x) => x.title === item.serialNumber
                                        ).value
                                      : item.value ?? 0
                                  )}
                                />

                                <div className="value">
                                  {alerts.find(
                                    (x) => x.title === item.serialNumber
                                  ) !== undefined
                                    ? alerts.find(
                                        (x) => x.title === item.serialNumber
                                      ).value
                                    : item.value ?? "data incoming"}
                                </div>
                                <div className="itemFeatures">
                                  <div>Serial Number: {item.serialNumber}</div>
                                  <div className="first">
                                    Critical Threshold: {item.thresholdCritical}
                                  </div>
                                  <div className="first">
                                    Medium Threshold: {item.thresholdMedium}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      );
                    })}
                </Grid>
              </div>
              {openControl && (
                <ControlPlantContainer
                  openControl={openControl}
                  setOpenControl={setOpenControl}
                />
              )}
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
}
